
import React from 'react';

interface StatsSummaryProps {
  chartData: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      tension: number;
    }>;
  };
}

const StatsSummary: React.FC<StatsSummaryProps> = ({ chartData }) => {
  // Calculate totals from real chart data
  const totalPresent = chartData.datasets[0].data.reduce((sum, value) => sum + value, 0);
  const totalLate = chartData.datasets[1].data.reduce((sum, value) => sum + value, 0);
  const totalAbsent = chartData.datasets[2].data.reduce((sum, value) => sum + value, 0);
  const grandTotal = totalPresent + totalLate + totalAbsent;
  
  const attendanceRate = grandTotal > 0 ? Math.round((totalPresent / grandTotal) * 100) : 0;
  const lateRate = grandTotal > 0 ? Math.round((totalLate / grandTotal) * 100) : 0;
  const absentRate = grandTotal > 0 ? Math.round((totalAbsent / grandTotal) * 100) : 0;
  
  return (
    <div className="mt-6 p-4 bg-gray-50 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4 text-gray-700">Period Summary</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">{totalPresent}</div>
          <div className="text-sm text-gray-600">Total Present</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-yellow-600">{totalLate}</div>
          <div className="text-sm text-gray-600">Total Late</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600">{totalAbsent}</div>
          <div className="text-sm text-gray-600">Total Absent</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{grandTotal}</div>
          <div className="text-sm text-gray-600">Grand Total</div>
        </div>
      </div>

      {grandTotal > 0 && (
        <div className="grid grid-cols-3 gap-4 pt-4 border-t">
          <div className="text-center">
            <div className="text-lg font-semibold text-green-600">{attendanceRate}%</div>
            <div className="text-xs text-gray-600">Attendance Rate</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-yellow-600">{lateRate}%</div>
            <div className="text-xs text-gray-600">Late Rate</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-red-600">{absentRate}%</div>
            <div className="text-xs text-gray-600">Absence Rate</div>
          </div>
        </div>
      )}
      
      {grandTotal === 0 && (
        <div className="text-center text-gray-500 py-4">
          <p>No attendance records found for the selected period.</p>
          <p className="text-sm mt-2">Mark teacher attendance to see data here.</p>
        </div>
      )}
    </div>
  );
};

export default StatsSummary;
